// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"cfb1dfbb","80":"1bac02ec","571":"3d9775a1","646":"3ee57429"}[chunkId] + ".chunk.js";
};